module.exports = {"TXTWCL_Featured":{"id":"TXTWCL_Featured","defaultMessage":"À l''affiche"}}